import React, { Fragment, useState } from 'react';
import useFetchData from '../../../helpers/useFetch';
import AppURL from '../../../constants/AppURL';
import { Grid } from '@mui/material';
import CategoryMasterCreateView from '../../../components/inventory/setup/master_category/CategoryMasterCreateView';
import CategoryMasterListView from '../../../components/inventory/setup/master_category/CategoryMasterListView';

const CategoryMasterCreateListView = () => {
    const [onURL, setOnURL] = useState(AppURL.InventoryURL + 'inventory/product/master/create/list/view/');
    const { data, loading, error, refetch } = useFetchData(onURL);
    const handleFormSuccess = (): void => {
        refetch();
    };
    return (
        <Fragment>
            <Grid container spacing={3}>
                <Grid item xl={6} md={6} sm={12} xs={12} lg={6}>
                    <CategoryMasterCreateView handleFormSuccess={handleFormSuccess} />
                </Grid>
                <Grid item xl={6} md={6} sm={12} xs={12} lg={6}>
                    <CategoryMasterListView handleFormSuccess={handleFormSuccess} setOnURL={setOnURL} results={data} error={error} loading={loading} />
                </Grid>
            </Grid>

        </Fragment>
    )
}

export default CategoryMasterCreateListView